import {USER_ROLES} from "@/constants";

export default class ProjectPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return true;
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    view(user, project)
    {
        if([USER_ROLES.USER].includes(user.role)) {
            return true;
        };

        if (project.project_manager_id === user.id) {
            return true;
        }
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    update(user, project)
    {
        if (project.is_locked) {
            if (!project.locked_by) {
                return false;
            }

            if (project.locked_by.id !== user.id) {
                return false;
            }
        }

        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    duplicate(user, project)
    {
        if (project.parent_id) { //duplicates can not be duplicated again
            return false;
        }
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    assign_disabilities(user, project)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    drop_disabilities(user, project)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER, USER_ROLES.FOREMAN].includes(user.role);
    }

    /**
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    complete_services(user, project)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    export(user, project)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    restore(user, project)
    {
        return [USER_ROLES.ADMIN].includes(user.role);
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    delete(user, project)
    {
        return [USER_ROLES.ADMIN].includes(user.role);
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    forceDelete(user, project)
    {
        //
    }

    /**
     * Determine whether the user can lock the project.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    lock(user, project)
    {
        if (project.is_locked) return false;

        return this.update(user, project);
    }

    /**
     * Determine whether the user can unlock the project.
     *
     * @param  {object}  user
     * @param  {object}  project
     * @return {mixed}
     */
    unlock(user, project)
    {
        const locked_by = project.locked_by || {};

        return (locked_by.id === user.id) || [USER_ROLES.ADMIN].includes(user.role);
    }
}
